import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=19a7bd90&scoped=true&"
import script from "./CompanyEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEdit.vue?vue&type=style&index=0&id=19a7bd90&scoped=true&lang=scss&"
import style1 from "./CompanyEdit.vue?vue&type=style&index=1&id=19a7bd90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7bd90",
  null
  
)

export default component.exports